import { useEffect } from 'react';
import { createMarkup } from 'utils/createMarkup/createMarkup';
import './Notification.scss';

const TTL_TIME = 5000;

type NotificationProps = {
  message: string;
  type: 'error' | 'info' | 'success';
  onClose?: () => void;
};

export const Notification = ({ message, type, onClose }: NotificationProps) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      onClose?.();
    }, TTL_TIME);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [onClose]);

  return (
    <div className={`Notification Notification--${type}`}>
      <div
        role="alert"
        className="Notification-message"
        dangerouslySetInnerHTML={createMarkup(message)}
      />
    </div>
  );
};
